export default __webpack_public_path__ + "static/media/ISCO CLASS-9_SYLLABUS_2025-26.011f85bd.pdf";